module.exports = __webpack_public_path__ + "static/media/43.a78faf47.png";